import { ReactComponent as Lisbyn } from 'assets/icons/icon-lisbyn.svg';

export default Lisbyn;
